import { render, staticRenderFns } from "./Representation.vue?vue&type=template&id=89f7c324&"
import script from "./Representation.vue?vue&type=script&lang=js&"
export * from "./Representation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports